const avatar = require("./images/official.jpg");

const images = { avatar };
const Assets = { images };

export default Assets;
